import $ from "n-zepto";
import cookieUtil from "./plugin/cookie-util";
import emojiRegex from "emoji-regex";
export default {
  install: function (Vue, options) {
    Vue.prototype.checkPhone = function (num) {
      var mobile = /^[1][0-9]\d{9}$/;
      var mobile2 = /^[１][０,１,２,３,４,５,６,７,８,９][０,１,２,３,４,５,６,７,８,９]{9}$/;
      return mobile.test(num) || mobile2.test(num);
    };
    Vue.prototype.checkPass = function (num) {
      var password = /^[A-Za-z0-9-_\~!:;|,·`@#\$\^&\*\.\(\)\[\]\{\}<>\\\/\'\"]{6,16}$/;
      return password.test(num);
    };
    Vue.prototype.checkName = function (num) {
      // var password = /^([\u4e00-\u9fa5]{2,10}|([A-Za-z]+\s?){2,10})$/;
      const allSpecialCharacters = new Set([
        // 英文标点和中文标点混合
        " ",
        "、",
        "·",
        "!",
        "！",
        "@",
        "＠",
        "#",
        "＃",
        "$",
        "＄",
        "%",
        "％",
        "^",
        "＾",
        "&",
        "＆",
        "*",
        "＊",
        "(",
        "（",
        ")",
        "）",
        "_",
        "－",
        "+",
        "＋",
        "=",
        "＝",
        "{",
        "｛",
        "}",
        "｝",
        "[",
        "［",
        "]",
        "］",
        "|",
        "｜",
        "\\",
        "＼",
        ";",
        "；",
        ":",
        "：",
        "'",
        "＇",
        '"',
        "＂",
        ",",
        "，",
        ".",
        "。",
        "<",
        "＜",
        ">",
        "＞",
        "/",
        "／",
        "?",
        "？",
        "~",
        "～",
        "`",
        "￥",
        "…",
        "—",
        "〈",
        "〉",
        "「",
        "」",
        "『",
        "』",
        "〖",
        "〗",
        "【",
        "】",
        "》",
        "《",
        "+",
        "-",
        "*",
        "/",
        "×",
        "÷",
        "±",
        "=",
        "≠",
        "<",
        ">",
        "≤",
        "≥",
        "≈",
        "∞",
        "∑",
        "∏",
        "√",
        "∫",
        "∆",
        "λ",
        "μ",
        "π",
        "σ",
        "→",
        "↔",
        "⇒",
        "∧",
        "∨",
        "¬",
        "⊕",
        "⊗",
        "⊥",
        "∥",
        "∼",
        "≅",
        // 货币符号
        "$",
        "€",
        "¥",
        "£",
        "₩",
        "₹",
        "฿",
        "₽",
        "₺",
        // 单位符号
        "°",
        "'",
        '"',
        "%",
        "‰",
        "µ",
        "∆",
        "λ",
        "μm",
        "mm",
        "cm",
        "km",
        "kg",
        "g",
        "mg",
        // 几何符号
        "∠",
        "⊥",
        "∥",
        "⊙",
        "△",
        "□",
        "■",
        "○",
        "●",
        "◯",
        // 箭头符号
        "→",
        "←",
        "↑",
        "↓",
        "↔",
        "⇐",
        "⇒",
        "⇔",
        "↩",
        "↪",
        "➔",
        "➡",
        "⬅",
        "⬆",
        "⬇",
        // 其他常用符号
        "§",
        "¶",
        "†",
        "‡",
        "•",
        "⁂",
        "№",
        "™",
        "©",
        "®",
        "℗",
        "℠",
      ]);
      if (!num.length || num.length < 2) return false;
      return !(
        [...num].some((char) => allSpecialCharacters.has(char)) ||
        emojiRegex().test(num)
      );
    };
    Vue.prototype.checkIdCard = function (num) {
      var idCard15 = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/;
      var idCard18 = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X]$/;
      return idCard15.test(num) || idCard18.test(num);
    };
    (Vue.prototype.checkNumFromZero = function (num) {
      var name = $.trim(num);
      var numbercode = /^[0-9]\d*$/;
      return numbercode.test(name);
    }),
      (Vue.prototype.checkCode = function (num) {
        var code = /^\d{6}$/;
        return code.test(num);
      });
    Vue.prototype.checkCode2 = function (num) {
      var code = /^\d{4}$/;
      return code.test(num);
    };
    Vue.prototype.elData = function (json) {
      return eval("(" + json + ")");
    };
    Vue.prototype.getNewAjax = function (
      url,
      data,
      success,
      error,
      neterr,
      headers
    ) {
      $.ajax({
        /*headers:{token: cookieUtil.get('usr-token')},*/
        type: "POST", //请求方式
        url: url,
        data: data,
        success: function (result) {
          if (!result) {
            return error && error(result);
          }
          switch (result.rcode) {
            case "000000":
              return success(result.rdata);
            default:
              return error && error(result);
          }
          return error && error(result);
        },
        error: neterr,
      });
    };
    Vue.prototype.getAjax = function (url, data, callback, errFun) {
      $.ajax({
        type: "get", //请求方式
        url: url,
        dataType: "json",
        crossDomain: true,
        contentType: "application/json;utf-8",
        data: data,
        success: function (data2) {
          //let json=eval('(' + data2 + ')');
          callback(data2);
        },
        error: errFun,
      });
    };
    /* 获取cookie*/
    Vue.prototype.setCookie = function (name, value, domain) {
      var d = new Date();
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      if (domain == "") {
        document.cookie = name + "=" + encodeURI(value) + "; path=/;" + expires;
      } else {
        document.cookie =
          name +
          "=" +
          encodeURI(value) +
          "; domain=.izhaowo.com;path=/;" +
          expires;
      }
    };
    /*清理cookie*/
    Vue.prototype.clearCookie = function (name, value, domain) {
      var d = new Date();
      d.setTime(d.getTime() - 1);
      var expires = "expires=" + d.toUTCString();
      if (domain == "") {
        document.cookie = name + "=" + encodeURI(value) + "; path=/;" + expires;
      } else {
        document.cookie =
          name +
          "=" +
          encodeURI(value) +
          "; domain=.izhaowo.com;path=/;" +
          expires;
      }
    };
    /*获取cookie*/
    Vue.prototype.getCookie = function (cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1);
        if (c.indexOf(name) != -1)
          return decodeURI(c.substring(name.length, c.length));
      }
      return "";
    };
  },
};



// WEBPACK FOOTER //
// ./src/valid.js